//src/components/Footer.js

import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";

const Footer = () => {
    return (
        <footer
            style={{
                background: "linear-gradient(180deg, #eef8ff 0%, #e6f4ff 100%)",
                borderTop: "1px solid #d9eef9",
                padding: "30px 0",
            }}
        >
            <div className="container">
                <div className="row g-4">

                    {/* Trusted */}
                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="d-flex align-items-center gap-3">

                            <svg width="42" height="42" viewBox="0 0 28 32" fill="none">
                                <path
                                    d="M14 1L2 6v8c0 8 5 14.5 12 16.5C21 28.5 26 22 26 14V6L14 1z"
                                    stroke="#28B7E7"
                                    strokeWidth="2"
                                />
                                <path
                                    d="M9 16l3 3 7-7"
                                    stroke="#28B7E7"
                                    strokeWidth="2.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                            <div>
                                <h6 className="mb-1 fw-bold">Trusted by millions</h6>
                                <small className="text-muted">
                                    Working for your protection.
                                </small>
                            </div>

                        </div>
                    </div>

                    {/* WhatsApp */}
                    {/* <div className="col-lg-3 col-md-6 col-12">
                        <div className="d-flex align-items-center gap-3">

                            <div
                                style={{
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    background: "#fff",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxShadow: "0 2px 8px rgba(0,0,0,.08)"
                                }}
                            >
                                <FaWhatsapp size={22} color="#25D366" />
                            </div>

                            <div>
                                <h6 className="mb-1 fw-bold">WhatsApp</h6>
                                <small className="text-muted">03XX-XXXXXXX</small>
                            </div>

                        </div>
                    </div> */}

                    {/* Helpline */}
                    {/* <div className="col-lg-4 col-md-6 col-12">
                        <div className="d-flex align-items-center gap-3">

                            <div
                                style={{
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    background: "#fff",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxShadow: "0 2px 8px rgba(0,0,0,.08)"
                                }}
                            >
                                <FiPhone size={20} color="#28B7E7" />
                            </div>

                            <div>
                                <h6 className="mb-1 fw-bold">Helpline</h6>
                                <small className="text-muted">XXXX</small>
                            </div>

                        </div>
                    </div> */}

                    {/* Email */}
                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="d-flex align-items-center gap-3">

                            <div
                                style={{
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    background: "#fff",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxShadow: "0 2px 8px rgba(0,0,0,.08)"
                                }}
                            >
                                <HiOutlineMail size={22} color="#28B7E7" />
                            </div>

                            <div>
                                <h6 className="mb-1 fw-bold">Email</h6>
                                <small className="text-muted">
                                    support@webdoc.com.pk
                                </small>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </footer>
    );
};

export default Footer;
